import React from 'react'
import classnames from 'classnames'
import { Button } from 'src/Components'

import styles from './StepFooterButton.module.scss'

export interface StepFooterProps {
  disableButton?: boolean
  children: React.ReactNode
  onClick?: () => void
  loading?: boolean
  optIn?: boolean
}

export const StepFooterButton = ({
  children,
  disableButton,
  onClick,
  loading,
  optIn,
}: StepFooterProps) => {
  return (
    <div>
      <Button
        fullWidth
        className={classnames(
          styles.nextButton,
          optIn && styles.optIn,
          disableButton && styles.disabled
        )}
        onClick={onClick}
        disabled={disableButton}
        loading={loading}
        primary
      >
        {children}
      </Button>
    </div>
  )
}
